/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Link } from "react-router-dom";
import "./Web1920129.css";

function Web1920129(props) {
  const { warp,  group281 } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-129 screen">
        <div className="overlap-group-23">
          <img className="warp-5" src={warp} />
          <div className="group-583-14">
            <Link to="/web-1920-10">
              <img className="group-281-1" src={group281} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Web1920129;
